import {DescriptionStyled} from "@/components/UI/Description/Description.styled";

const Description = ({children, size, color, ...props}) => {
    return (
        <DescriptionStyled {...props} size={size} color={color}>
            {children}
        </DescriptionStyled>
    );
};

export default Description;